import * as tslib_1 from "tslib";
import { reduxKey, defaultSliceState } from './constants';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
function getLoveStateSlice(state) {
    if (!state || !state.hasOwnProperty(reduxKey)) {
        return;
    }
    return state[reduxKey];
}
export function getLoveState(state, itemId, defaultState) {
    var slice = getLoveStateSlice(state);
    var itemSlice = slice && slice[itemId];
    var defaultLoveScore = defaultState && defaultState.loveScore;
    var defaultLoveCount = defaultState && defaultState.loveCount;
    if (itemSlice) {
        if (itemSlice.loveScore !== undefined) {
            // all is good, slice already has loveScore
            return itemSlice;
        }
        // we need to fill with a default
        return tslib_1.__assign({}, defaultSliceState, itemSlice, { loveScore: defaultLoveScore === undefined
                ? defaultSliceState.loveScore
                : defaultLoveScore, loveCount: defaultLoveCount === undefined
                ? defaultSliceState.loveCount
                : defaultLoveCount });
    }
    // we dont' have a state, but we have a default, can use that
    if (defaultLoveScore !== undefined) {
        return tslib_1.__assign({}, defaultSliceState, defaultState);
    }
    // we have nothing
    return defaultSliceState;
}
export function getMeterState(state, itemId, defaultState) {
    var slice = getLoveStateSlice(state);
    var _a = getLoveState(state, itemId, defaultState), loveScore = _a.loveScore, loveCount = _a.loveCount;
    var sliceLoveScore = slice && slice[itemId] && slice[itemId].loveScore;
    var defaultLoveScore = defaultState && defaultState.loveScore;
    return {
        loveScore: loveScore,
        loveCount: loveCount,
        hasLoved: sliceLoveScore === undefined ? !!defaultLoveScore : !!sliceLoveScore,
    };
}
export function getLoveScore(state, itemId, defaultState) {
    return getLoveState(state, itemId, defaultState).loveScore;
}
export function getIsLoading(state, itemId, defaultState) {
    return getLoveState(state, itemId, defaultState).isLoading;
}
export function getLoveCount(state, itemId, defaultState) {
    return getLoveState(state, itemId, defaultState).loveCount;
}
export function getLoveSuggestions(state, forDeviationId) {
    var _a = getLoveState(state, forDeviationId) || {}, _b = _a.suggestions, suggestionIds = _b === void 0 ? [] : _b, loveScore = _a.loveScore, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c;
    var suggestions = getDeviationsByIds(state, suggestionIds);
    var isLove = loveScore > 0;
    return {
        hasSuggestions: suggestions.length > 0,
        deviations: suggestions || [],
        isLoading: isLoading,
        type: (isLove ? 'love' : 'hate'),
    };
}
//# sourceMappingURL=selectors.js.map